module.exports = __webpack_public_path__ + "fonts/Nunito-SemiBold.b1982ff7.woff2";